<template>
    <v-select
        v-model="object"
        :options="items"
        :get-option-key="getOptionKey"
        @search="search"
    >
        <template slot="option" slot-scope="option">
            <div class="media">
                <img
                    class="mr-3 rounded"
                    :src="option.photo"
                    height="45"
                    alt="Foto"
                />
                <div class="media-body">
                    <h5 class="mt-0">{{ option.label }}</h5>
                </div>
            </div>
        </template>
        <span slot="no-options">Escriba al menos 3 caracteres para buscar.</span>
    </v-select>
</template>
<script>
import vigilanceRepository from '../../../../repositories/vigilance.repository'
export default {
    inheritAttrs: false,
    props: {
        minSize: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            object: null,
            results: [],
            searchRequestId: 0,
        }
    },
    watch: {
        object(val) {
            this.$emit('input', val ? val.document : '')
        },
    },
    computed: {
        items() {
            if (!Array.isArray(this.results) || !this.results.length) return []

            const seenKeys = new Set()

            return this.results.reduce((items, item, index) => {
                if (!item) return items

                const type = !!item.internal ? 'Interno' : 'Visitante'
                const isVehicle = item.plate != null && item.plate !== ''
                const optionKey = this.buildOptionKey(item, isVehicle, index)

                if (seenKeys.has(optionKey)) return items
                seenKeys.add(optionKey)

                if (isVehicle) {
                    const photos = Array.isArray(item.vehicle_photos)
                        ? item.vehicle_photos
                        : []
                    items.push({
                        id: optionKey,
                        label: `${item.brand || ''} (${item.plate}) - ${type}`,
                        document: item.plate,
                        type,
                        photo:
                            photos.length && photos[0].photo_url
                                ? photos[0].photo_url
                                : 'images/genericcar.png',
                    })
                } else {
                    items.push({
                        id: optionKey,
                        label: `${item.name || ''} (${item.document || ''}) - ${type}`,
                        document: item.document,
                        type,
                        photo: item.photo
                            ? item.photo
                            : 'images/avatar_empty.png',
                    })
                }

                return items
            }, [])
        },
    },
    methods: {
        buildOptionKey(item, isVehicle, index) {
            const prefix = isVehicle ? 'vehicle' : 'person'
            const identifier =
                item.id != null
                    ? item.id
                    : isVehicle
                      ? item.plate
                      : item.document

            return `${prefix}-${identifier != null ? identifier : index}`
        },
        getOptionKey(option) {
            return option.id
        },
        search(search, loading) {
            const term = search.trim()

            if (term.length < this.minSize) {
                this.searchRequestId++
                this.results = []
                loading(false)
                return
            }

            const requestId = ++this.searchRequestId
            loading(true)

            vigilanceRepository
                .searchPersonOrVehicle(this.client.id, term)
                .then((data) => {
                    if (requestId !== this.searchRequestId) return

                    this.results = Array.isArray(data) ? data : []
                    loading(false)
                })
                .catch(() => {
                    if (requestId !== this.searchRequestId) return

                    loading(false)
                    toastr.error(
                        'Ocurrió un error al consultar las personas o vehículos'
                    )
                })
        },
    },
}
</script>
